import { styled } from "@monolith-forensics/monolith-ui";
import { File, FileStatus } from "../../files.types";
import { UploadQueueItem } from "../../Hooks/useUploadQueue";
import { PhotoOverlayActions } from "./PhotoOverlayActions";
import { PhotoUploadPlaceholder } from "./PhotoUploadPlaceholder";

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  .photo-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 5px;
    padding: 10px;
    height: 100%;
    .photo {
      max-height: 150px;
      max-width: 150px;
      object-fit: cover;
      image-orientation: from-image;
    }
    .photo-name {
      margin-top: 15px;
      font-size: 10px;
      color: ${({ theme }) => theme.palette.text.secondary};
    }
  }
`;

export type PhotoGridItemProps = {
  file: File;
  upload?: UploadQueueItem;
  onView: (file: File) => void;
  onDownload?: (file: File) => void;
  onDelete?: (file: File) => void;
  onRename?: (file: File) => void;
  onDismiss?: (uuid: string) => void;
  onImageError?: (file: File) => void;
};

export const PhotoGridItem = ({
  file,
  upload,
  onView,
  onDownload,
  onDelete,
  onRename,
  onDismiss,
  onImageError,
}: PhotoGridItemProps) => {
  const inFlight = upload && upload.phase !== "complete";

  if (inFlight || file.status === FileStatus.UPLOADING) {
    return (
      <StyledContainer>
        <PhotoUploadPlaceholder
          name={file.name}
          upload={upload}
          onDismiss={
            upload && onDismiss ? () => onDismiss(upload.uuid) : undefined
          }
          onDelete={!upload && onDelete ? () => onDelete(file) : undefined}
        />
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      <PhotoOverlayActions
        file={file}
        onView={onView}
        onDownload={onDownload}
        onDelete={onDelete}
        onRename={onRename}
      />
      <div className="photo-item">
        <img
          className="photo"
          src={file.link}
          alt={file.name}
          loading="lazy"
          onError={onImageError ? () => onImageError(file) : undefined}
        />
        <div className="photo-name">{file.name}</div>
      </div>
    </StyledContainer>
  );
};
